<template>
  <b-modal
    id="modalSaveCalculationProductionCompletelyRelieveLoad"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-relieve-load">
      <svg
        class="m-relieve-load-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-relieve-load-title">Частично освободить от нагрузки</div>
      <div class="m-relieve-load-fullname">{{ record.employee.value }}</div>
      <div class="m-relieve-load-inputs">
        <div class="row">
          <div class="col col-6 col-md-3 mb-4">
            <c-input
              v-model="salaryLocal"
              class="m-relieve-load-inputs-salary"
              :class="{ 'm-relieve-load-inputs-salary-required': salaryErrorMessage.length > 0 }"
              label="Оклад, ฿"
              placeholder="0"
              label-full-name="Оклад, ฿"
              type="price-number"
              :input-text-condition="salaryErrorMessage"
            />
          </div>
          <div class="col col-6 col-md-3 mb-4">
            <c-input
              v-model="standardRatioLocal"
              class="m-relieve-load-inputs-standart-ratio"
              :class="{ 'm-relieve-load-inputs-standart-ratio-required': standardRatioErrorMessage.length > 0 }"
              label="Коэфф. норм."
              placeholder="0"
              label-full-name="Коэффициент норматива"
              type="price-number"
              :input-text-condition="standardRatioErrorMessage"
            />
          </div>
          <div class="col col-6 col-md-3 mb-4">
            <c-input
              v-model="bonusRateLocal"
              class="m-relieve-load-inputs-bonus-rate"
              :class="{ 'm-relieve-load-inputs-bonus-rate-required': bonusRateLocalErrorMessage.length > 0 }"
              label="Коэфф. прем-я"
              placeholder="0"
              label-full-name="Коэффициент премирования"
              type="price-number"
              :input-text-condition="bonusRateLocalErrorMessage"
            />
          </div>
          <div class="col col-6 col-md-3 mb-4">
            <c-input
              v-model="depreciationCoefficientLocal"
              class="m-relieve-load-inputs-depreciation-coefficient"
              :class="{
                'm-relieve-load-inputs-depreciation-coefficient-required':
                  depreciationCoefficientErrorMessage.length > 0,
              }"
              label="Коэфф. депр-я"
              placeholder="0"
              label-full-name="Коэффициент депремирования"
              type="price-number"
              :input-text-condition="depreciationCoefficientErrorMessage"
            />
          </div>
        </div>
      </div>

      <div class="m-relieve-load-actions">
        <c-button size="large" class="m-relieve-load-actions-cancel" label="Отменить" @click="closeModal" />
        <c-button class="m-relieve-load-actions-save" label="Сохранить" color="blue" size="large" @click="submitForm" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls/button";

export default {
  name: "m-partially-relieve-load",

  components: {
    "c-input": Input,
    "c-button": Button,
  },

  props: ["active", "record"],

  data() {
    return {
      localActive: false,
      salaryLocal: "",
      salaryErrorMessage: "",
      standardRatioLocal: "",
      standardRatioErrorMessage: "",
      bonusRateLocal: "",
      bonusRateLocalErrorMessage: "",
      depreciationCoefficientLocal: "",
      depreciationCoefficientErrorMessage: "",
      submitAttempt: false,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.salaryLocal = "";
          this.salaryErrorMessage = "";
          this.standardRatioLocal = "";
          this.standardRatioErrorMessage = "";
          this.bonusRateLocal = "";
          this.bonusRateLocalErrorMessage = "";
          this.depreciationCoefficientLocal = "";
          this.depreciationCoefficientErrorMessage = "";
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    salaryLocal(value) {
      if (this.submitAttempt) {
        if (value === null || value === "") {
          this.salaryErrorMessage = "Обязательное поле";
        } else {
          this.salaryErrorMessage = "";
        }
      }
    },
    standardRatioLocal(value) {
      if (this.submitAttempt) {
        if (value === null || value === "") {
          this.standardRatioErrorMessage = "Обязательное поле";
        } else {
          this.standardRatioErrorMessage = "";
        }
      }
    },
    bonusRateLocal(value) {
      if (this.submitAttempt) {
        if (value === null || value === "") {
          this.bonusRateLocalErrorMessage = "Обязательное поле";
        } else {
          this.bonusRateLocalErrorMessage = "";
        }
      }
    },
    depreciationCoefficientLocal(value) {
      if (this.submitAttempt) {
        if (value === null || value === "") {
          this.depreciationCoefficientErrorMessage = "Обязательное поле";
        } else {
          this.depreciationCoefficientErrorMessage = "";
        }
      }
    },
  },

  methods: {
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    onShowModal() {
      setTimeout(() => {
        this.salaryLocal = this.record.salary.value;
        this.standardRatioLocal = this.record.ratio_standart.value;
        this.bonusRateLocal = this.record.bonus_rate.value;
        this.depreciationCoefficientLocal = this.record.deprivation_coefficient.value;
      }, 100);
    },
    closeModal() {
      this.localActive = false;
    },
    submitForm() {
      let isValidForm = true;

      if (this.salaryLocal === null || this.salaryLocal === "") {
        isValidForm = false;
        this.salaryErrorMessage = "Обязательное поле";
        this.submitAttempt = true;
      }

      if (this.standardRatioLocal === null || this.standardRatioLocal === "") {
        isValidForm = false;
        this.standardRatioErrorMessage = "Обязательное поле";
        this.submitAttempt = true;
      }

      if (this.bonusRateLocal === null || this.bonusRateLocal === "") {
        isValidForm = false;
        this.bonusRateLocalErrorMessage = "Обязательное поле";
        this.submitAttempt = true;
      }

      if (this.depreciationCoefficientLocal === null || this.depreciationCoefficientLocal === "") {
        isValidForm = false;
        this.depreciationCoefficientErrorMessage = "Обязательное поле";
        this.submitAttempt = true;
      }

      if (isValidForm) {
        this.$emit("setLoadParams", {
          salary: this.salaryLocal,
          standartRatio: this.standardRatioLocal,
          bonusRate: this.bonusRateLocal,
          depreciationCoefficient: this.depreciationCoefficientLocal,
        });
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-relieve-load {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-fullname {
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
  }

  &-inputs {
    margin-top: 17px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      margin-bottom: 7px;
    }

    &-salary {
      &-required {
        padding-bottom: 22px;
      }
    }

    &-standart-ratio {
      &-required {
        padding-bottom: 22px;
      }
    }

    &-load-bonus-rate {
      &-required {
        padding-bottom: 22px;
      }
    }

    &-load-depreciation-coefficient {
      &-required {
        padding-bottom: 22px;
      }
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 6px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
